<template>
<div>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        dense
        style="margin-left: 15px; margin-right: 15px; margin-top: 25px; margin-bottom: -15px;"
        ref="search"
        v-model="full_text"
        @keydown.enter="onClickFirstRow"
    >
    </v-text-field>

    <v-list dense>

    <v-list-item 
        v-for="(item, index) in menu_items"
        :key="'menu_item_'+index"
        v-on:click="onClickMenuItem($event,item)"
        link 
    >
        <v-list-item-action><v-icon>{{item.icon}}</v-icon></v-list-item-action>
        <v-list-item-content>
            <v-list-item-title>{{item.text}}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>

    </v-list>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: function() { return false; }
        },
    },
    
    data() {
        return {
            full_text: null,
        }
    },

   
    methods: {
        onUpdateDrawer(value)
        {
            if ( value )
            {
                window.setTimeout(
                    () => {
                        this.$refs['drawer-search'].focus();
                    },
                    100
                );
            }
        },

        onClickFirstRow()
        {
            if ( this.menu_items.length == 0 )
                return;

            this.onClickMenuItem({}, this.menu_items[0]);
        },

        onClickMenuItem(event, item)
        {
            if ( item.page != null )
            {
                this.quietPush(item, event);
                return;
            }

            item.on_click();
        },

        quietPush(item, event)
        {
            this.closeDrawer();

            event = this.$rc.cloneEvent(event);

            if ( item.link_out )
            {
                event.ctrlKey = true;
            }

            let route = {
                'name': item.page,
                'params' : {
                        'employee_id' : this.$rc.$state.employee_id,
                        'organization_id' : this.$rc.$state.organization_id,
                    },
                'query': item.query,
            };

            this.$rc.navigationClick(this.$router, route, event);
        },

        onClickHome() {
            this.quietPush({'page': 'home'});
        },

        onClickSignOut() 
        {
            if ( this.$rc.$state.offerSignOutReturnToAdminAccount() )
            {
                // Sign back in as the system administrator account
                this.signInAsSystemAdminAccount();
                return;
            }

            this.closeDrawer();

            if ( this.$rc.$state.isAuthActorSystemAdmin() )
            {
                this.confirmSystemAdminSignout();
                return;
            }
            
            this.doSignOut();
        },

        signInAsSystemAdminAccount()
        {
            this.$rc.signInAsAuthAccount(
                    (data) => {
                        this.$rc.hideSpinner();
                        
                        this.$rc.next_page_snackbar('You are now signed in as '+this.$rc.$state.getAuthActorUsername(),3000);

                        this.$router.push({
                            'name': 'home',
                        }).catch(e=>{}); // swallow any exception
                    },
                
                    () => {
                        this.$rc.hideSpinner();
                        this.$rc.alert('Error','Unable to complete API call');
                    },
                );
        },

        confirmSystemAdminSignout()
        {
            this.$rc.confirm({
                    'title': 'System Administrator Sign Out',
                    'body': 'You are about to sign out from your system administrator account.  Are you <b>absolutely sure</b> that you want to do this?',
                    'btn_text_ok': 'Sign Out',
                    'btn_text_cancel': 'Cancel',
                    'text_to_confirm_message': 'To sign out, type "confirm" below.',
                    'text_to_confirm': 'confirm',
                    'on_ok': () => {
                        this.doSignOut();
                    },
                });
        },

        closeDrawer()
        {
            this.$emit('input', false);
        },

        doSignOut()
        {
             this.$rc.signOut();
             this.$router.push({
                'name': 'sign-in',
                'params' : {
                }
             });
        },

        onClickCRM(content_type)
        {
            this.closeDrawer();

            this.$router.push({
                'name': 'crm-home',
                'params' : {
                    'organization_id' : this.$rc.$state.organization_id,
                    'content_type' : content_type
                }
            }).catch(e=>{}); // swallow any exception
        },

        fullTextFilter(full_text, item)
        {
            full_text = (full_text ?? '').trim().toLowerCase();

            if ( full_text.length == 0 )
            {
                return !(item.search_only ?? false);
            }

            let tokens = full_text.split(/(\s+)/);
            tokens = tokens.filter((token) => token.trim().length > 0);

            return tokens.every((token) => this.itemText(item).toLowerCase().includes(token));
        },

        itemText(item)
        {
            let ret = item.text;

            if ( item.alt_text != null )
            {
                ret += ' '+item.alt_text;
            }

            return ret;
        },

        onClickAdmin(route)
        {
            route.params = route.params ?? {};
            route.params.employee_id = route.params.employee_id ?? this.$rc.$state.employee_id;
            route.params.organization_id = route.params.organization_id ?? this.$rc.$state.organization_id;

            if ( this.$rc.$state.isSystemAdmin() )
            {
                this.$router.push(route);
            }
            else
            {
                this.$rc.newSignInAsAuthAccount({ 'after_route': route });
            }
        },
    },

    computed: {
        menu_items()
        {
            let ret = [];

            if ( this.$rc.$state.getOrganizationSpecialPurpose() )
            {
                ret.push({'text': 'Home', 'icon': 'mdi-home', 'on_click': this.onClickHome});
                ret.push({'text': 'Sign Out', 'icon': 'mdi-logout', 'on_click': this.onClickSignOut});

                return ret;
            }

            ret.push({'text': 'Home', 'icon': 'mdi-home', 'on_click': this.onClickHome});
            ret.push({'text': 'Account Settings', 'icon': 'mdi-cog', 'page': 'settings-account'});
            ret.push({'text': 'Organization Settings', 'icon': 'mdi-domain', 'page': 'settings-organization'});
            ret.push({'text': 'Contacts', 'icon': 'mdi-contacts', 'page': 'fulltext-search-contacts'});
            ret.push({'text': 'Lists', 'icon': 'mdi-format-list-bulleted-square', 'page': 'search-lists'});
            ret.push({'text': 'Contact Requests', 'icon': 'mdi-card-account-mail', 'page': 'search-open-contact-requests'});
            ret.push({'text': 'Web Chat Requests', 'icon': 'mdi-web', 'page': 'search-inbox-contact-requests-without-start-inbox'});
            ret.push({'text': 'Consent Register', 'icon': 'mdi-account-group', 'page': 'search-consent-register'});

            if ( this.$rc.$state.showBulkMessages() )
            {
                ret.push({'text': 'Bulk Messages', 'icon': 'mdi-comment-text-multiple', 'page': 'search-bulk-messages'});
            }

            ret.push({'text': 'Saved Messages', 'icon': 'mdi-message-draw', 'page': 'search-saved-messages'});
            ret.push({'text': 'Payments', 'icon': 'mdi-cash-multiple', 'page': 'search-payments'});
            ret.push({'text': 'Schedule', 'icon': 'mdi-watch', 'page': 'settings-organization-schedule'});

            // All of the CRM links...
            for ( let i = 0; i < this.active_crms.length; i++ )
            {
                let crm = this.active_crms[i];

                ret.push({'text': crm.text, 'icon': 'mdi-vector-link', 'on_click': () => {this.onClickCRM(crm.value)} });
            }

            if ( this.$rc.$state.isFINRAEnabled() && this.$rc.$state.isOrganizationAdmin() )
            {
                ret.push({'text': 'Compliance', 'icon': 'mdi-cloud-upload-outline', 'page': 'compliance-all'});
            }

            ret.push({'text': 'Automated Messages', 'icon': 'mdi-robot', 'page': 'auto-messages-home'});

            if ( this.$rc.$state.isAuthActorSystemAdmin() )
            {
                ret.push({'text': 'Tests', 'icon': 'mdi-xml',  'search_only': true, 'on_click': () => { this.onClickAdmin({name: 'all-tests'});}});
                ret.push({'text': 'Test > Input', 'icon': 'mdi-xml',  'search_only': true, 'on_click': () => { this.onClickAdmin({name: 'test-input'});}});


                ret.push({'text': 'Admin', 'icon': 'mdi-lock-check',  'on_click': () => { this.onClickAdmin({ name:'all-admin'}); } } );
                ret.push({'text': 'Admin > Organization Billing Settings', 'icon': 'mdi-invoice-list-outline', 'page': 'admin-billing-one-organization', 'search_only': true});
                ret.push({'text': 'Admin > Provision', 'icon': 'mdi-cloud-sync-outline', 'page': 'provision', 'search_only': true});
                ret.push({'text': 'Admin > Provision New Organization', 'alt_text': 'Create Organization', 'icon': 'mdi-cloud-plus-outline', 'on_click': () => { this.onClickAdmin({name: 'admin-create-organization', params: {organization_id: this.$rc.uuidv4()}});}, 'search_only': true});
                ret.push({'text': 'Admin > Rate Card', 'icon': 'mdi-invoice-list-outline', 'page': 'edit-organization-rate-card', 'search_only': true});
                ret.push({'text': 'Admin > RedChirp CRM Notes', 'icon': 'mdi-note-multiple-outline', 'page': 'rc-crm-view-organization', 'search_only': true});
                ret.push({'text': 'Admin > TCR Campaign Registration', 'icon': 'mdi-human-greeting', 'page': 'welcome_admin_tcr_campaign_registration', 'search_only': true});
                ret.push({'text': 'Admin > Password Reset Requests', 'icon': 'mdi-lock-reset', 'page': 'admin-password-reset-links', 'search_only': true});

                ret.push({'text': 'Alert Delivery Settings', 'icon': 'mdi-cog', 'page': 'alert-delivery-preferences', 'search_only': true});

                ret.push({'text': 'Admin > Bulk Message Templates', 'icon': 'mdi-cog', 'on_click': () => { 

                    this.$router.push({
                        'name': 'admin-bulk-message-templates',
                        'params' : {
                            'organization_id': this.$rc.$state.organization_id,
                        },
                        'query': {
                            'admin': true,
                        },
                    });

                }, 'search_only': true});
            }

            ret.push({'text': 'Analytics', 'icon': 'mdi-google-analytics', 'page': 'all-analytics'});
            ret.push({'text': 'Help & Tutorials', 'icon': 'mdi-help-box-multiple-outline', 'page': 'help'});
            ret.push({'text': 'Sign Out', 'icon': 'mdi-logout', 'on_click': this.onClickSignOut});

            // These are all of the menu items that only show when searched...
            {
                

                ret.push({'text': 'Account Change Log', 'icon': 'mdi-format-list-bulleted-square', 'page': 'account-change-log', 'search_only': true});
                ret.push({'text': 'Account Access Log', 'icon': 'mdi-format-list-bulleted-square', 'page': 'account-access-log', 'search_only': true});
                
                ret.push({'text': 'Default Messaging Opt In Form', 'icon': 'mdi-form-select', 'page': 'default-opt-in-form', 'search_only': true, 'link_out': true});

                ret.push({'text': 'Events', 'icon': 'mdi-code-less-than-or-equal', 'page': 'events', 'search_only': true});
                ret.push({'text': 'Shipping Events (Second Generation)', 'icon': 'mdi-truck', 'page': 'events', query: {'initial-event-types': 'second-generation-shipping-events'}, 'search_only': true});

                ret.push({'text': 'Welcome Screen', 'icon': 'mdi-human-greeting', 'page': 'welcome_ordinary_user', 'search_only': true});

                ret.push({'text': 'Vendor Assesment Center', 'icon': 'mdi-open-in-new', 'page': 'https://redchirp.com/vendor-assessment-resource-center', 'search_only': true, 'link_out': true});

                ret.push({'text': 'Analytics > Bulk Messages', 'icon': 'mdi-google-analytics', 'page': 'analytics-all-bulk-messages', 'search_only': true});
                ret.push({'text': 'Analytics > Keyword Auto Responses', 'icon': 'mdi-google-analytics', 'page': 'reporting-keyword-auto-response', 'search_only': true});
                ret.push({'text': 'Analytics > Phone Number Validation', 'icon': 'mdi-google-analytics', 'page': 'search-endpoint-validation-details', 'search_only': true});
                ret.push({'text': 'Analytics > Web Chat Requests', 'icon': 'mdi-google-analytics', 'page': 'analytics-web-chat', 'search_only': true});
            

                ret.push({'text': 'Sign In As', 'icon': 'mdi-clipboard-account-outline', 'on_click': () => { this.$emit('sign-in-as'); }, 'search_only': true});

                ret.push({'text': 'Settings > API Keys', 'icon': 'mdi-cog', 'page': 'settings-organization-api-keys', 'search_only': true});
                ret.push({'text': 'Settings > Blocked (Spam) Numbers', 'icon': 'mdi-cog', 'page': 'settings-organization-spam-numbers', 'search_only': true});
                ret.push({'text': 'Settings > Branded Link Shortener', 'icon': 'mdi-cog', 'page': 'settings-organization-branded-link-shortener', 'search_only': true});
                ret.push({'text': 'Settings > Custom Keywords', 'icon': 'mdi-cog', 'page': 'settings-organization-keyword-auto-responses', 'search_only': true});
                ret.push({'text': 'Settings > CTIA Keywords', 'icon': 'mdi-cog', 'page': 'settings-organization-ctia-keyword-auto-responses', 'search_only': true});
                ret.push({'text': 'Settings > Forms', 'icon': 'mdi-cog', 'page': 'search-forms', 'search_only': true});
                ret.push({'text': 'Settings > Inboxes', 'icon': 'mdi-cog', 'page': 'edit-inboxes', 'search_only': true});
                ret.push({'text': 'Settings > Introductions', 'icon': 'mdi-cog', 'page': 'settings-organization-introductions', 'search_only': true});
                ret.push({'text': 'Settings > Order Attribution', 'icon': 'mdi-cog', 'page': 'settings-organization-order-attribution', 'search_only': true});
                ret.push({'text': 'Settings > RedChirp Billing', 'icon': 'mdi-cog', 'page': 'organization-redchirp-billing-settings', 'search_only': true});
                ret.push({'text': 'Settings > RedChirp Tags', 'icon': 'mdi-cog', 'page': 'settings-organization-tags', 'search_only': true});
                ret.push({'text': 'Settings > Webchat Widget', 'icon': 'mdi-cog', 'page': 'settings-organization-widget', 'search_only': true});
                ret.push({'text': 'Settings > Custom Consent Agreements', 'icon': 'mdi-cog', 'page': 'settings-custom-consent-agreements', 'search_only': true});

                ret.push({'text': 'Bulk Message Templates', 'icon': 'mdi-comment-text-multiple', 'page': 'bulk-message-template-create-page', 'search_only': true});
            }


            ret = ret.filter((item) => this.fullTextFilter(this.full_text, item));
        

            return ret;
        },


        active_crms() 
        {
            let raw = this.$rc.enumChoices('integration_name', false);
            let ret = [];

            for ( let i = 0; i < raw.length; i++ )
            {
                let cur = raw[i];

                if( cur.value == 'redchirp' ) continue;
                if( cur.value == 'fare-harbor' ) continue;
                if( cur.value == 'mailchimp' ) continue;
                if( cur.value == 'klaviyo' ) continue;
                if( cur.value == 'wine-shipping' ) continue; 
                if( cur.value == 'calendly' ) continue; 

                if ( !this.$rc.$state.isCRMEnabled(cur.value) ) continue;

                ret.push(cur);
            }

            return ret;
        },
    },

    watch: {
        value(new_value, old_value) {
            
            if ( new_value )
            {
                this.full_text = null;
                window.setTimeout(
                    () => {
                        this.$refs['search'].focus();
                    },
                    100
                );
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>